var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gg"},[_c('div',{staticClass:"gg-score",style:(_vm.scoreStyle)},[_vm._v(_vm._s(_vm.score)+" ")]),_c('el-progress',{staticClass:"print-progress",staticStyle:{"display":"inline-block","width":"100%","margin-left":"20px"},attrs:{"stroke-width":10,"color":_vm.color,"percentage":_vm.percentage(_vm.rank),"format":_vm.format}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }